// extracted by mini-css-extract-plugin
export default {"centered":"streaming_centered__eRO7j"};